// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "bundle.bff29f611f3f3eded1ac8e22e3c8e7fc.css";
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "96759c464ba8951063ab77fcbe362236" + ".css";
};